class ProductModal extends HTMLElement {
    constructor() {
        super();    
        this.CACHE = new Map();
        this.CACHE_LIMIT = 10;

        this.handle = this.dataset.productHandle;
        this.url = this.url || null;
        this.productId = this.dataset.productId;
        this.sectionId = this.sectionId || this.dataset.sectionId; // Which section template to render
        this.toggleElement = this.toggleElement || null;
        this.trackingId = this.dataset.trackingId || null;
        this.innerToggleElement = this.innerToggleElement || null;
        this.content = this.querySelector('pmd-content');
        this.close = this.querySelector('pmd-close');
        this.loader = this.querySelector('pmd-loader');
        this.align = this.dataset.align || null;


        // Set form
        this.outerForm = this.outerSetForm || null;
        this.formType = this.formType || 'add-to-cart';
        this.productSet = this.formType == 'add-to-set' ? true : false;
        this.cartType = this.cartType || 'page';
        
        this.close.addEventListener('click', () => {
            this.hide();
        });

        this.addEventListener('click', (e) => {
            if (e.target.classList.contains('active')) {
              this.hide()
            }
          })


    }

    initFormInputs() {
        const forms = this.querySelectorAll('form');

        if(forms) {
            forms.forEach(form => {
                const templates = form.querySelectorAll('template');

                templates.forEach(template => {
                    const clone = template.content.cloneNode(true);
                    if(template.getAttribute('id') == 'variant_id') {
                    } else if(template.getAttribute('id') == 'attribution_form') {
                        const inputElement = clone.querySelector('input');
                        if (inputElement) {
                            inputElement.setAttribute('value', `${this.formType}`); 
                            console.log('attribution_form', inputElement);
                        }
                    } else if(template.getAttribute('id') == 'attribution_url') {
                        const inputElement = clone.querySelector('input');
                        if (inputElement) {
                            inputElement.setAttribute('value', `${window.location.pathname}`); 
                            console.log('attribution_url', inputElement);
                        }
                    } else if(template.getAttribute('id') == 'attribution_section_id') {
                        const inputElement = clone.querySelector('input');
                        if (inputElement) {
                            inputElement.setAttribute('value', `${this.trackingId}`); 
                            console.log('attribution_section_id', inputElement);
                        }
                    } else if (this.trackingId === 'cart-recommendations' && template.getAttribute('id') == 'cart-recommendation-for') {
                        const inputElement = clone.querySelector('input');
                        if (inputElement) {
                            inputElement.setAttribute('value', `${this.cartRecommendationFor}`);
                        }
                    }
                    
                    form.append(clone);
                });
            });
        }
    }
    
    initGallery(template) {
        const slider = template.querySelector('css-slider');
        const isActive = slider.classList.contains('enabled');

        if(slider && ! isActive ) {
            slider.initSlider();
            slider.changeSlide(0);
        } else {
            slider.resetSlider();
        }

        template.querySelector('product-variants').onVariantChange();
    }

    initVariantSelectors() {

        const variantSelectors = this.querySelectorAll('product-variants');
        if (variantSelectors) {
            variantSelectors.forEach(selector => {
                selector.init();
                selector.addEventListener('VARIANT_CHANGE', (e) => {
                    this.onVariantChange(e);
                });
            });
        }
    }

    onVariantChange(e) {

        console.log('called internal onVariantChange');
        const currentVariant = e.target.currentVariant;
        const currentVariantFeaturedMedia = currentVariant.featured_media_id;
        const gallery = e.target.closest('.product-modal--content').parentElement.querySelector('css-slider');
        const variants = e.target.querySelectorAll('[data-js-product-variant]');

        const price = e.target.closest('.product-modal--content').querySelector('[final-price]');

        if(e.target.hasAttribute('data-show-free-wording')) {
            price.innerHTML = `<span style="color: var(--color-brand);">FREE</span>`
        } else {
            price.innerHTML = `<span class="igPrice">${this._formatMoney(currentVariant.price, KROWN.settings.shop_money_format)}</span>`;
        }

        variants.forEach(variant => {
            const option = variant.querySelector('input:checked');
            const label = variant.querySelector('[data-js-current-option-label]');
            label.textContent = option.value;
        });

        if (!gallery) {
            console.error('Gallery not found');
            return;
        }

        const currentVariantImage = gallery.querySelector(`.product-gallery-item[data-media-id="${currentVariantFeaturedMedia}"]`);

        if (gallery) {
            if (gallery.sliderEnabled) {
                gallery.changeSlide(currentVariantImage.dataset.index);
            } else {
                gallery.scrollTo({
                    left: currentVariantImage.offsetLeft,
                    behavior: 'auto'
                });
            }
        }

    }

    initForm(){
        const forms = this.querySelectorAll('.form');
        forms.forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                if(this.formType == 'add-to-set') {
                    this.handleSetForm(e);
                } else {
                    this.handleAddToCart(e);
                }
            });
        });
    }

    handleAddToCart(e) {
        const form = e.target;
        const submitButton = form.querySelector('[type="submit"]');

		submitButton.classList.add('working');

		const body = this._serializeForm(form);
		let alert = '';

		fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
			body,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'X-Requested-With': 'XMLHttpRequest'
			},
			method: 'POST'
		})
			.then(response => response.json())
			.then(response => {
				if ( response.status == 422 ) {
					// wrong stock logic alert
					alert = document.createElement('span');
					alert.className = 'alert alert--error';
					if ( typeof response.description === 'string' ) {
						alert.innerHTML = response.description;
					} else {
						alert.innerHTML = response.message;
					}
					if ( this.cartType == 'page' ) {
						if ( document.getElementById('product-page-form-error-cart-alert') ) {
							document.getElementById('product-page-form-error-cart-alert').remove();
						}
						alert.style.marginTop = '1em';
						alert.style.marginBottom = '0';
						alert.id = 'product-page-form-error-cart-alert';
						this.form.parentElement.append(alert);
						return false;
					}
					return fetch('?section_id=helper-cart');
				} else {
					if ( this.cartType == 'page' ) {
						document.location.href = KROWN.settings.routes.cart_url;
						return false;
					} else {
						return fetch('?section_id=helper-cart');
					}
				}
			})
			.then(response => response.text())
			.then(text => {

				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;


				if ( document.getElementById('AjaxCartForm') ) {

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					if (document.querySelector('cart-recommendations') ) {
						document.querySelector('cart-recommendations').generateRecommendations();
					}

					if ( alert != '' ) {
						document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
					});

				}
				
				this.dispatchEvent(this.ADD_TO_CART);
                this.shopifyPixel().addToCart();

				// a11y
				if ( document.getElementById('screen-reader-info') ) {
					document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
					setTimeout(()=>{
						document.getElementById('screen-reader-info').innerText = '';
					}, 1000);
				}

			})
			.catch(e => {
				console.log(e);
			})
			.finally(() => {
				submitButton.classList.remove('working');
                document.getElementById('site-cart-sidebar')?.show();
                this.hide();
			});
    }


	_serializeForm(form) {
		let arr = [];
		Array.prototype.slice.call(form.elements).forEach(function(field) {
			if (
				!field.name ||
				field.disabled ||
				['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
			)
				return;
			if (field.type === 'select-multiple') {
				Array.prototype.slice.call(field.options).forEach(function(option) {
					if (!option.selected) return;
					arr.push(
						encodeURIComponent(field.name) +
							'=' +
							encodeURIComponent(option.value)
					);
				});
				return;
			}
			if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
				return;
			arr.push(
				encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
			);
		});
		return arr.join('&');
	}


    handleSetForm(e){
        e.preventDefault();
        const card = this.outerForm.closest('.product-item'); 
        const product = e.target.closest('[data-js-product-template]');
        const productForm = e.target.closest('form');
        const productVariants = product.querySelector('product-variants');
        const productCurrentVariant = productVariants.currentVariant;

        // Update card form values
        card.querySelector('input[name="product-id"]').value = productForm.querySelector('input[name="product-id"]').value;
        card.querySelector('input[name="properties[_modal_attribution_form]"]').value = this.formType;
        card.querySelector('input[name="properties[_modal_attribution_url]"]').value = window.location.pathname;
        card.querySelector('input[name="properties[_modal_attribution_section_name]"]').value = this.trackingId;
        const cardVariantId = card.querySelector('input[name="id"]');
        cardVariantId.value = productForm.querySelector('input[name="id"]').value;
        cardVariantId.setAttribute('data-price', productCurrentVariant.price);
        cardVariantId.setAttribute('data-compare-at-price', productCurrentVariant.compare_at_price);

        // Update toggle element and card information
        this.toggleElement.setAttribute('data-variant-id', cardVariantId.value);
        this.toggleElement.setAttribute('data-product-handle', product.dataset.handle);
        card.querySelector('.product-item__title-set').textContent = product.dataset.title;

        // Update product variant title
        const productOptionsArray = Array.from(productVariants.querySelectorAll('[data-js-current-option-label]')).map(option => option.textContent);
        const productVariantTitle = productOptionsArray.join(' / ');
        card.querySelector('[data-js-selected-variant]').textContent = productVariantTitle;

        // Update product images
        const modalProductImage = product.querySelector(`.product-gallery-item[data-media-id="${productCurrentVariant.featured_media_id}"] img`) || product.querySelectorAll('.product-gallery-item img')[0];
        const productImage = card.querySelector('.product-item__image img');
        productImage.style.opacity = 0;
        productImage.src = modalProductImage.getAttribute('src');
        productImage.srcset = modalProductImage.getAttribute('srcset');
        productImage.onload = () => {
            productImage.style.opacity = 1;
            card.querySelector('.product-item__image figure').classList.add('clip-reveal');
            setTimeout(() => {
                card.querySelector('.product-item__image figure').classList.remove('clip-reveal');
            }, 300);
        };

        // Initialize product set if available
        if (this.productSet) {
            this.productSet.initSetForm();
            this.productSet.checkSet();
        }

        this.hide();
    }

    initProducts() {
        let activeProduct = null; // Declare a variable to store the active product

        const products = this.querySelectorAll('[data-js-product-template]');
        if (products) {
            products.forEach(product => {
                const handle = product.dataset.handle;
                if (handle == this.handle) {
                    product.classList.add('active');
                    this.setAttribute('data-handle', this.handle);
                    this.setAttribute('data-id', this.productId);
                    this.setAttribute('data-title', product.dataset.title);
                    activeProduct = product; // Store the active product
                }
            });
        }

        if (activeProduct && activeProduct.querySelector('jack-custom-guide')) {
            activeProduct.querySelector('jack-custom-guide').init();
        }

        if (activeProduct) {
            this.initGallery(activeProduct);
        }
    }


    onProductChange(event) {
        event.preventDefault();
        const currentProduct = this.querySelector('[data-js-product-template].active');
        const currentPosition = event.target.dataset.position;
        const currentVariant = currentProduct.querySelector('product-variants').currentVariant;
        const currentVariantOptions = currentVariant.options;
        const newHandle = event.target.dataset.handle; 
        const newValue = event.target.dataset.value;
        const newProduct = this.querySelector(`[data-js-product-template][data-handle="${newHandle}"]`);

        currentProduct.classList.remove('active');
        newProduct.classList.add('active');

        this.setAttribute('data-handle', newProduct.dataset.handle); 
        this.setAttribute('data-title', newProduct.dataset.title);
        this.setAttribute('data-id', newProduct.dataset.id);

        currentVariantOptions.map((option, index) => {
            const variantContainer = newProduct.querySelectorAll(`[data-js-product-variant]`)[index].querySelector(`[data-js-product-variant-container]`); 

            if ( variantContainer.dataset.jsProductVariantContainer == 'radio' ) {
                if ( index == currentPosition ) {
                    variantContainer.querySelector(`input[value="${newValue.replace(/"/g, '\\"')}"]`).checked = true;
                } else {
                    variantContainer.querySelector(`input[value="${option.replace(/"/g, '\\"')}"]`).checked = true;
                }
            }
        });

        this.initGallery(newProduct);
    }

    

    onInnerProductChange(currentVariant) {
        const currentVariantOptions = currentVariant.options;
        const newHandle = this.handle;
        console.log('newHandle', newHandle);
        const newProduct = this.querySelector(`[data-js-product-template][data-handle="${newHandle}"]`);
        const variants = newProduct.querySelectorAll('[data-js-product-variant]');
        
        currentVariantOptions.map((option, index) => {
            const variantContainer = newProduct.querySelectorAll(`[data-js-product-variant]`)[index].querySelector(`[data-js-product-variant-container]`); 
            if ( variantContainer.dataset.jsProductVariantContainer == 'radio' ) {
                variantContainer.querySelector(`input[value="${option.replace(/"/g, '\\"')}"]`).checked = true;
            } else {
                console.log(variantContainer);
            }
        });

        variants.forEach(variant => {
            const option = variant.querySelector('input:checked');
            const label = variant.querySelector('[data-js-current-option-label]');
            label.textContent = option.value;
        });

        newProduct.querySelector('product-variants').onVariantChange();
    }

    _formatMoney(cents, format) {

        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }

        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
            thousands = thousands || ',';
            decimal = decimal || '.';

            if (isNaN(number) || number === null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            const parts = number.split('.');
            const dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                '$1' + thousands
            );
            const centsAmount = parts[1] ? decimal + parts[1] : '';

            return dollarsAmount + centsAmount + KROWN.settings.iso_code;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
            case 'amount_with_apostrophe_separator':
                value = formatWithDelimiters(cents, 2, "'");
                break;
        }

        return formatString.replace(placeholderRegex, value).replace('.00','');
    }

    getUrl(handle) {
        if (this.url) {
            return `${window.location.origin}${this.url}${this.url.includes('?') ? '&' : '?'}section_id=${this.sectionId}`;
        } else if (KROWN.settings.routes.root_url != '/') {
            return `${KROWN.settings.routes.root_url}/products/${handle}?section_id=${this.sectionId}`;
        } else {
            return `/products/${handle}?section_id=${this.sectionId}`;
        }
    }

    async fetchProduct(handle) {
        let activeProduct = this.querySelector('[data-js-product-template].active');
        let currentVariant = null;
        if (activeProduct) {
          currentVariant = activeProduct.querySelector('product-variants').currentVariant;
          activeProduct.querySelector('button.add-to-cart').classList.add('working');
        }
    
        let url = this.getUrl(handle);
    
        // --- Check if content is already cached ---
        if (this.CACHE && this.CACHE.has(url)) {
          const cachedContent = this.CACHE.get(url);
          let parser = new DOMParser();
          let doc = parser.parseFromString(cachedContent, 'text/html');
          let sectionContent = doc.querySelector(`#shopify-section-${this.sectionId}`);
          if (sectionContent) {
            this.content.innerHTML = sectionContent.innerHTML;
            this.appendProductHeader();
          } else {
            console.error('Section not found in the cached content');
          }
          // Perform the common initialization steps
          this.initFormInputs();
          if (this.innerToggleElement) {
            this.onInnerProductChange(currentVariant);
            this.innerToggleElement = undefined;
          }
          this.querySelectorAll('[data-js-change-product]').forEach(el => {
            el.addEventListener('click', (event) => this.onProductChange(event));
          });
          this.initVariantSelectors();
          this.initProducts();
          if (this.toggleElement.classList.contains('working')) {
            this.toggleElement.classList.remove('working');
          }
          this.initForm();
          this.loaded();
          return;
        }
        // --- End Cache Check ---
    
        try {
          let response = await fetch(url);
          let product = await response.text();
          // Cache the fetched content
          
          this.CACHE.set(url, product);
          if (this.CACHE.size > this.CACHE_LIMIT) {
            const oldestKey = this.CACHE.keys().next().value;
            this.CACHE.delete(oldestKey);
          }
    
          let parser = new DOMParser();
          let doc = parser.parseFromString(product, 'text/html');
          let sectionContent = doc.querySelector(`#shopify-section-${this.sectionId}`);
          if (sectionContent) {
            this.content.innerHTML = sectionContent.innerHTML;
            this.appendProductHeader();
          } else {
            console.error('Section not found in the fetched content');
          }
        } catch (error) {
          this.error(error);
        } finally {
          this.initFormInputs();
          if (this.innerToggleElement) {
            this.onInnerProductChange(currentVariant);
            this.innerToggleElement = undefined;
          }
          this.querySelectorAll('[data-js-change-product]').forEach(el => {
            el.addEventListener('click', (event) => this.onProductChange(event));
          });
          this.initVariantSelectors();
          this.initProducts();
          if (this.toggleElement.classList.contains('working')) {
            this.toggleElement.classList.remove('working');
          }
          this.initForm();
          this.loaded();
        }
    }

    appendProductHeader() {
        if (this.querySelector('template.product-header-template')) {
            const productHeaderTemplate = this.querySelector('template.product-header-template');
            const productTemplates = this.querySelectorAll('[data-js-product-template]');
            productTemplates.forEach(product => {
                const container = product.querySelector('.product-modal--header');
                if (productHeaderTemplate.content && productHeaderTemplate.content.hasChildNodes()) {
                    container.appendChild(productHeaderTemplate.content.cloneNode(true));
                }
            });
            return true;
        }

        return false
    }

    hide() {
        const content = this.querySelectorAll('pmd-content > *');
        
        if (!!this.dataset.trackingId) {
            this.removeAttribute('data-tracking-id')
        }
        if (!!this.dataset.handle) {
            this.removeAttribute('data-handle')
        }
        if (!!this.dataset.id) {
            this.removeAttribute('data-id')
        }
        if (!!this.dataset.title) {
            this.removeAttribute('data-title')
        }
        

        // closing animation
        this.classList.add('closing');
        setTimeout(() => {
            this.classList.remove('closing');
            if(content && content.length) {
                content.forEach((el) => {
                  el.remove();
                })
              }
              this.url = null; 

              document.body.classList.remove('modal-open');
              this.classList.remove('active'); 
              this.classList.contains('loaded') && this.classList.remove('loaded')
              this.removeAttribute('id')
      
              
        }, 300);
    }

    shopifyPixel() {
        return {
          addToCart: () =>
            Shopify.analytics.publish('modal_add_to_cart', {event: 'modal_add_to_cart', trackingId: this.trackingId }),
          openModal: () =>
            Shopify.analytics.publish('modal_open', {event: 'modal_open', trackingId: this.trackingId })
        }
    }

    show() {
        document.body.classList.add('modal-open');

        if(this.innerToggleElement) { 
            this.classList.add('inner-working')
        } else {
            this.setAttribute('data-align', this.align);
            this.setAttribute('data-tracking-id', this.trackingId);
            this.classList.add('active')
            this.classList.add('working')
            this.loader.classList.add('working');
            this.loader.querySelector('.button__preloader-text').innerHTML = `Loading your next pair of ${this.toggleElement.dataset.productTitle}...`;
        }
        
        this.fetchProduct(this.handle);
        this.shopifyPixel().openModal();
    }


    loaded() {

        if(!this.classList.contains('loaded')) {
            this.classList.add('loaded')
        }

        if(this.classList.contains('working')) {
            this.classList.remove('working')
            this.loader.classList.remove('working');
        }
        
        if(this.classList.contains('inner-working')) {
            this.classList.remove('inner-working')
        }
    }

    error(error) {
        console.error('Fetch error:', error);
        this.innerHTML = `<div>Please make sure you're connected to the internet and try again! :)</div>`;
    }

}

customElements.get('product-modal') || customElements.define('product-modal', ProductModal);


class ProductModalToggle extends HTMLElement {
    constructor() {
        super();

        this.productModal = document.querySelector('product-modal');

        console.log('this.sectionId', this.dataset.sectionId);

        this.addEventListener('click', (e) => {
            e.preventDefault();
            this.classList.add('working');

            if (this.productModal) {
                this.productModal.handle = this.dataset.productHandle;
                this.productModal.productId = this.dataset.productId;
                const useUrl = this.dataset.productUrl ? true : false;

                this.productModal.sectionId = this.dataset.sectionId;
                this.productModal.toggleElement = this;
                this.productModal.trackingId = this.dataset.trackingId;
                if (useUrl) { this.productModal.url = this.dataset.productUrl }

                if (this.classList.contains('product-item')) {
                    this.productModal.productSet = this.closest('.products-set');
                }

                if (this.dataset.cartRecommendationFor) {
                    this.productModal.cartRecommendationFor = this.dataset.cartRecommendationFor;
                }

                if(this.dataset.formType == 'add-to-set') {
                    this.productModal.formType = 'add-to-set';
                    this.productModal.sectionId = 'helper-product-modal-sets';
                    this.productModal.outerForm = this;
                } else if (! this.dataset.formType) {
                    this.productModal.sectionId = 'helper-product-modal';
                }

                if(this.dataset.align) {
                    this.productModal.align = this.dataset.align;
                } else {
                    this.productModal.align = null;
                }

                if(this.dataset.cartType) {
                    this.productModal.cartType = this.dataset.cartType;
                }

                this.productModal.show();
            }
        })
    }
}

customElements.get('product-modal-toggle') || customElements.define('product-modal-toggle', ProductModalToggle);

class InnerProductModalToggle extends HTMLElement {
    constructor() {
        super();

        this.productModal = document.querySelector('product-modal');

        this.addEventListener('click', (e) => {
            e.preventDefault();
            this.classList.add('working');

            if (this.productModal) {
                this.productModal.handle = this.dataset.productHandle;
                this.productModal.productId = this.dataset.productId;
                this.productModal.innerToggleElement = this;
                this.productModal.url = null;
                this.productModal.show();
            }
        })
    }
}

customElements.get('inner-product-modal-toggle') || customElements.define('inner-product-modal-toggle', InnerProductModalToggle);